import { SET_ORIGINAL_RATE_JSON } from '../actions/types';

/**
 * @memberof module:util
 * @function
 * @name updateOriginalRateJson
 * @description Update original saved rate json, add bookNowPrice to correct rate card based on id.
 * This updated rate json is used in [getNewRatesByUUID]{@link module:util.getNewRatesByUUID} to compare with new rate json by UUID.
 *
 * @param {string} id - id of a single rate card
 * @param {number} bookNowPrice - book now price on a single rate card
 * @param {Redux.Store} getState - Whole redux store state
 * @param {Function} dispatch - It does dispatch a redux action to update the redux state
 * @returns {void}
 *
 */
export const updateOriginalRateJson = (
  id,
  bookNowPrice,
  pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked,
  getState,
  dispatch
) => {
  // check if id exist or not
  // check for transport mode type
  const type = getState().route.queryParams.type;
  const typePrefix =
    (type === 'api-fcl' && 'fcl') ||
    (type === 'api-lcl' && 'lcl') ||
    (type === 'api-air' && 'air');
  let originalSavedRateJson = getState().route.originalRateData.rateJson;
  const oldItemArr =
    originalSavedRateJson &&
    originalSavedRateJson.rates &&
    originalSavedRateJson.rates[typePrefix];

  if (!Array.isArray(oldItemArr)) {
    return;
  }

  const updatedRateJson = {
    ...originalSavedRateJson,
    rates: { [typePrefix]: [...getNewArr(oldItemArr, id, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked)] },
  };

  // update redux store
  dispatch({
    type: SET_ORIGINAL_RATE_JSON, //originalRateData
    payload: {
      rateJson: updatedRateJson,
    },
  });
};

const getNewArr = (oldItemArr, newItemId, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked) => {
  let tempFinalArr = [];
  tempFinalArr =
    Array.isArray(oldItemArr) &&
    oldItemArr.map((item) => {
      if (item.id === newItemId) {
        return { ...item, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked };
      }
      return item;
    });
  return tempFinalArr;
};
